import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Dialog, DialogContent, DialogTitle, IconButton, Chip, CircularProgress, Box, Typography } from '@material-ui/core'
import { HeadsetMic, Close } from '@material-ui/icons'

const useStyles = makeStyles((theme) => ({
  supportButton: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    zIndex: 9999,
    backgroundColor: '#d05d02',
    color: '#fff',
    fontSize: '14px',
    fontWeight: 'bold',
    padding: '12px 16px',
    borderRadius: '25px',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    '&:hover': {
      backgroundColor: '#a74a00',
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
    },
  },
  dialog: {
    '& .MuiDialog-paper': {
      width: '80%',
      height: '700px',
      maxWidth: '90vw',
      maxHeight: '90vh',
    },
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    backgroundColor: '#f5f5f5',
  },
  dialogContent: {
    padding: 0,
    height: '100%',
    overflow: 'hidden',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
    background: 'transparent',
  },
  closeButton: {
    color: '#666',
  },
}))

function SupportWidget({ open: externalOpen, onClose: externalOnClose }) {
  const classes = useStyles()
  const [internalOpen, setInternalOpen] = useState(false)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  // Se externalOpen for passado, usa controle externo, senão usa interno
  const open = externalOpen !== undefined ? externalOpen : internalOpen
  const onClose = externalOnClose || (() => setInternalOpen(false))

  const handleOpen = () => {
    if (externalOpen === undefined) {
      setInternalOpen(true)
      setLoading(true)
      setError(false)
    }
  }

  const handleClose = () => {
    onClose()
    setLoading(true)
    setError(false)
  }

  const handleIframeLoad = () => {
    setLoading(false)
    setError(false)
  }

  const handleIframeError = () => {
    setLoading(false)
    setError(true)
  }

  // Reset loading state when dialog opens
  useEffect(() => {
    if (open) {
      setLoading(true)
      setError(false)
    }
  }, [open])

  return (
    <>
      <div
        className={classes.supportButton}
        onClick={handleOpen}
        title="Precisa de ajuda? Clique aqui para solicitar suporte"
        aria-label="Solicitar Suporte"
      >
        <HeadsetMic />
        <span>Precisa de ajuda?</span>
      </div>

      <Dialog
        open={open}
        onClose={handleClose}
        className={classes.dialog}
        maxWidth={false}
        fullWidth={false}
      >
        <DialogTitle className={classes.dialogTitle}>
          <span>Solicitar Suporte</span>
          <IconButton
            onClick={handleClose}
            className={classes.closeButton}
            aria-label="Fechar"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        
        <DialogContent className={classes.dialogContent}>
          {loading && (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              height="100%"
              style={{ backgroundColor: '#f9f9f9' }}
            >
              <CircularProgress size={50} style={{ color: '#d05d02', marginBottom: '16px' }} />
              <Typography variant="h6" style={{ color: '#666' }}>
                Carregando formulário...
              </Typography>
            </Box>
          )}

          {error && !loading && (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              height="100%"
              style={{ backgroundColor: '#f9f9f9' }}
            >
              <Typography variant="h6" style={{ color: '#d32f2f', marginBottom: '8px' }}>
                Erro ao carregar formulário
              </Typography>
              <Typography variant="body2" style={{ color: '#666', textAlign: 'center' }}>
                Tente novamente mais tarde ou entre em contato conosco por outros meios.
              </Typography>
            </Box>
          )}

          <iframe
            className={classes.iframe}
            src="https://forms.clickup.com/90131818130/f/2ky4ctmj-1193/JPL2RF76AZ00ZKQZC4"
            title="Formulário de Suporte"
            onLoad={handleIframeLoad}
            onError={handleIframeError}
            style={{ display: loading || error ? 'none' : 'block' }}
            onWheel=""
          />
        </DialogContent>
      </Dialog>

      {/* Script do ClickUp - carregado apenas quando necessário */}
      {open && (
        <script
          async
          src="https://app-cdn.clickup.com/assets/js/forms-embed/v1.js"
        />
      )}
    </>
  )
}

export default SupportWidget
